<template>
<div>
  <div class="m-background m-background--graph"></div>
  <Header></Header>
    <div class="l-container l-container--with-header">
      <div class="columns">
        <div class="column">
          <!-- <img :src="['~@/assets/images/characters/challenge--'] + getLevelImage" /> -->
          <img v-if="getLevel === 1"
           class="m-speech-bubble__media" src="~@/assets/images/characters/challenge-1.svg" />
          <img v-if="getLevel === 2"
            class="m-speech-bubble__media" src="~@/assets/images/characters/challenge-2.svg" />
          <img v-if="getLevel === 3"
            class="m-speech-bubble__media" src="~@/assets/images/characters/challenge-3.svg" />
          <img v-if="getLevel === 4"
            class="m-speech-bubble__media" src="~@/assets/images/characters/challenge-4.svg" />
        </div>
        <div class="column">
          <div class="m-speech-bubble">
            <h3 class="m-speech-bubble__title--blue">Challenge {{ getLevel }}:</h3>
            <p v-html="getLevelIntro"></p>
            <a class="m-btn m-btn__secondary m-btn__secondary--with-text"
              @click="getFirstQuestion(getLevel)">Question 1
              <img class="m-btn__arrow" src="~@/assets/images/white-arrow.png" />
            </a>
          </div>
        </div>
      </div>
    </div>
</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import Header from '../components/header/Header';

export default {
  components: {
    Header,
  },
  computed: {
    ...mapGetters(['getLevel', 'getCurrentLevelDetail']),
    getLevelIntro() {
      const level = this.getCurrentLevelDetail(this.getLevel);
      return level.intro;
    },
    getLevelImage() {
      const level = this.getCurrentLevelDetail(this.getLevel);
      return level.image;
    },
  },
  methods: {
    ...mapActions(['increaseLevel', 'setQuestionIndex', 'resetQuestionIndex']),
    goToQuestion(QId) {
      this.$router.push({ name: 'question', params: { id: QId } });
    },
    getFirstQuestion(level) {
      this.resetQuestionIndex();
      const questions = this.$store.state.questions.filter(question => question.level === level);
      const firstQuestion = questions[0].id;
      this.goToQuestion(firstQuestion);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/LevelIntro.vue